import React from 'react';
import { Link } from 'react-router-dom';
import { Coins, PlusCircle } from 'lucide-react';

interface CreditStatusProps {
  credits?: number;
}

const CreditStatus: React.FC<CreditStatusProps> = ({ credits = 0 }) => {
  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center">
          <Coins className="h-6 w-6 text-primary mr-2" />
          <h2 className="text-xl font-semibold">Mon solde de crédits</h2>
        </div>
        <Link
          to="/credits/purchase"
          className="btn btn-primary flex items-center"
        >
          <PlusCircle className="h-4 w-4 mr-2" />
          Recharger mon compte
        </Link>
      </div>

      <div className="bg-gradient-to-br from-primary/5 to-primary/10 rounded-lg p-6 mb-4">
        <p className="text-gray-600 mb-1">Crédits disponibles</p>
        <p className="text-3xl font-bold text-primary">{credits || 0}</p>
        {credits > 0 && (
          <p className="text-sm text-gray-600 mt-2">
            Vous pouvez estimer {credits} adresse{credits > 1 ? 's' : ''} différente{credits > 1 ? 's' : ''}
          </p>
        )}
      </div>

      <div className="text-sm text-gray-500">
        <p>Chaque crédit vous permet d'estimer une adresse différente avec un niveau de détail professionnel.</p>
        <p className="mt-2">Les crédits n'expirent jamais et vous pouvez réaliser des estimations illimitées pour chaque adresse.</p>
        <p className="mt-2">Besoin de plusieurs crédits ? <Link to="/credits/purchase" className="text-primary hover:underline">Profitez de nos packs économiques</Link></p>
      </div>
    </div>
  );
};

export default CreditStatus;